import isEmpty from 'lodash/isEmpty';
import {
  colorPaletteBlue700,
  colorPalettePurple500,
  colorPaletteGreen700,
  colorBaseGreyDark,
} from 'haven-design-system/build/typescript/es6';
import {
  Job,
  JobStatus,
  WorksReportsInterface,
} from '../../types';

export const getJobStatus = (job: Job, records: WorksReportsInterface) => {
  if (
    job.status === 'scheduled'
    && !isEmpty(job?.reportIds)
    && records
  ) {
    // find if the latest report has been started yet
    const latestReportId = job.reportIds?.reduce((prev: string | null, curr): string | null => {
      const prevRecord = prev ? (records[prev] || null) : null;
      const currRecord = curr ? (records[curr] || null) : null;
      if (prevRecord === null) return curr;
      if (currRecord === null) return prev;
      return prevRecord.updatedAt > currRecord.updatedAt ? prev : curr;
    }, null);

    const record = latestReportId ? records[latestReportId] : null;

    if (record && !!record.startedAt) {
      return JobStatus.InProgress;
    }
  }
  return job.status;
};

export const getJobStatusBadgeColor = (status: JobStatus) => {
  switch (status) {
    case JobStatus.Scheduled:
      return colorPaletteBlue700;
    case JobStatus.InProgress:
      return colorPalettePurple500;
    case JobStatus.Completed:
      return colorPaletteGreen700;
    case JobStatus.Cancelled:
      return colorBaseGreyDark;
    case JobStatus.Reschedule:
      return colorPaletteBlue700;
    default:
      return 'transparent';
  }
};
